import DashboardIcon from "@mui/icons-material/Dashboard";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import ListIcon from "@mui/icons-material/List";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SecurityIcon from '@mui/icons-material/Security';
import MessageIcon from '@mui/icons-material/Message';
import SettingsIcon from '@mui/icons-material/Settings';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionIcon from '@mui/icons-material/Description';
import ChecklistIcon from '@mui/icons-material/Checklist';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

export const drawerMenu = [
    {
      text: "Dashboard",
      to: "/dashboard",
      icon: <DashboardIcon />,
    },
    {
      text: "Appointments",
      to: "/appointments",
      icon: <CalendarTodayIcon />,
    },
    {
      text: "Schedule",
      to: "/schedule",
      icon: <CalendarTodayIcon />,
    },
    {
      text: "Customer Record",
      to: "/customerrecord",
      icon: <AssignmentIcon />,
    },
    // {
    //   text: "Orders",
    //   to: "/order",
    //   icon: <ShoppingCartIcon />,
    // },
    {
      text: "Reporting",
      to: "/reporting",
      icon: <PlaylistAddCheckIcon />,
    },
    {
      text: "Exam Templates",
      to: "/templates",
      icon: <DescriptionIcon />,
    },
    {
      text: "Inventory",
      to: "/inventory",
      icon: <ListIcon />,
    },
    {
      text: "Task List",
      to: "/tasks",
      icon: <ChecklistIcon />,
    },
    // Divider for admin section
    {
      divider: true
    },
    // Admin section items
    {
      text: "Employees",
      to: "/employees",
      icon: <PeopleIcon />,
    },
    {
      text: "Locations",
      to: "/locations",
      icon: <LocationOnIcon />,
    },
    {
      text: "Security",
      to: "/security",
      icon: <SecurityIcon />,
    },
    {
      text: "Audit Logs",
      to: "/audit",
      icon: <HistoryIcon />,
    },
    {
      text: "Recent Activity",
      to: "/activity",
      icon: <HistoryIcon />,
    },
    {
      text: "Time Tracking",
      to: "/time-tracking",
      icon: <AccessTimeIcon />,
    },
    {
      text: "Messaging",
      to: "/messaging",
      icon: <MessageIcon />,
    },
    {
      text: "Tenant Settings",
      to: "/settings",
      icon: <SettingsIcon />,
    },
    {
      text: "Valid Data",
      to: "/validdata",
      icon: <SettingsIcon />,
    }
  ];